import type { Action } from 'state/actions';

import type { columnDefinitions, DailyBlotterColumns } from '../dailyBlotter.model';

export function columnsReducer(state: columnDefinitions = { columns: [] }, action: Action): columnDefinitions {
  switch (action.type) {
    case 'DAILY_BLOTTER_COLUMNS_RECEIVED':
      return {
        ...state,
        columns: (action.columns as DailyBlotterColumns).data.columnDefinitions,
      };

    default:
      return state;
  }
}
